import React, {useEffect, useState} from 'react';
import {Controller, useForm} from "react-hook-form";
import Select from "react-select";
import ReCAPTCHA from "react-google-recaptcha";
import ReactStars from "react-stars/dist/react-stars";
import {fetchTrips, notify} from "./utils/utils";
import axiosConfig from "./utils/axiosConfig";
import {ToastContainer} from "react-toastify";
import HeaderSubPageTiny from "./partial/HeaderSubPageTiny";


const ReferencesForm = ({...props}) => {

    const {
        control,
        reset,
        trigger,
        register,
        handleSubmit,
        formState: {errors},
    } = useForm()

    const [isLoading, setIsLoading] = useState(false);
    const [isTripsLoading, setIsTripsLoading] = useState(true);
    const [tripOptions, setTripOptions] = useState([]);
    const [isTripRating, setIsTripRating] = useState(true);

    //const reCaptchaRef = useRef(null);
    const reCaptchaRef = React.createRef();

    const submitRating = async (data) => {
        try {
            await axiosConfig.post('/references', data,
                {'Content-Type': 'application/json'});
            reset();
            notify("Vielen Dank für Ihre Bewertung. Wir werden Ihre Meldung umgehend bearbeiten und die Bewertung prüfen.", "success")
            setIsLoading(false);
        } catch (error) {
            //console.log(error);
            //throw error
            setIsLoading(false);
            notify(error.message)
        }
    }
    const onSubmit = async (data, event) => {
        setIsLoading(true);

        // reCaptcha
        event.preventDefault()
        const captchaValue = await reCaptchaRef.current.executeAsync();

        if (!captchaValue) {
            notify("Bitte versuchen sie es erneut!")
            setIsLoading(false);
            return;
        }

        data["reCaptchaToken"] = captchaValue;
        trigger().then((check) => {
            //console.log(data)
            if (check) {
                submitRating(data);
            }
        })
    };

    useEffect(() => {
        document.title = `${props.partner?.name} - Bewertungen`;
        fetchTrips().then((trips) => {
            const arr = []
            trips?.map((trip) => arr.push({value: trip?.REISE_ID, label: `${trip?.Destination} - ${trip?.Kurztitel}`}));
            setTripOptions([...tripOptions, ...arr])
            setIsTripsLoading(false)
        })
    }, [register, props.partner])

    return (
        <div className="single-product travel_tour-page travel_tour">
            <ToastContainer/>
            <div className="site wrapper-content">
                <HeaderSubPageTiny title={'Bewertungen'} subtitle={'Bewertungen'}></HeaderSubPageTiny>
                <section className="content-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8  col-sm-12 aligncenter">
                                <h1 className="post_list_title">
                                    <span><strong>Bewertung abgeben</strong></span>
                                </h1>
                                <h2>
                                    Vertrauen ist der Anfang …
                                </h2>
                                <div className="alert alert-info d-flex align-items-center ">
                                    <div className="d-flex flex-column">

                                        <p className="p-wrap">
                                            Ihre Bewertung wird anonym veröffentlicht. Ihr vollständiger Name und Ihre
                                            E-Mail-Adresse werden nicht angezeigt.
                                            <br/>
                                            Mit * gekennzeichnete Felder sind erforderlich.
                                        </p>

                                        <p>Bitte geben Sie hier Ihre Anmerkung zur Bewertung ein. Wir werden Ihre
                                            Meldung
                                            umgehend bearbeiten und die Bewertung prüfen.</p>
                                    </div>
                                </div>

                                <form onSubmit={handleSubmit(onSubmit)} noValidate="novalidate">

                                    <input type="hidden" name="agencyNo"
                                           value={props.partner.agency_no}
                                           {...register(`agencyNo`)}/>


                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group mb-3 ">
                                                <fieldset>
                                                    <legend className="d-none">Bewertung type</legend>
                                                    <div className="form-check d-flex align-items-center">
                                                        <input className="form-check-input" type="radio"
                                                               value="true"
                                                               id="isCatalog1"
                                                               checked={isTripRating === true}
                                                               onClick={(e) => setIsTripRating(true)}
                                                               {...register(`isTripProspect`, {
                                                                   required: true
                                                               })}
                                                        />
                                                        <label className="form-check-label"
                                                               htmlFor="isCatalog1">
                                                            Reise Bewertung
                                                        </label>
                                                    </div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <input className="form-check-input" type="radio"
                                                               value="false"
                                                               id="isCatalog2"
                                                               checked={isTripRating === false}
                                                               onClick={(e) => setIsTripRating(false)}
                                                               {...register(`isTripProspect`, {
                                                                   required: true
                                                               })}
                                                        />
                                                        <label className="form-check-label"
                                                               htmlFor="isCatalog2">
                                                            Allgemeine Bewertung
                                                        </label>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </div>
                                    </div>

                                    {isTripRating &&
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="trip">Reisen auswählen<span
                                                        className="required">*</span></label>
                                                    <Controller
                                                        control={control}
                                                        name="trip"
                                                        rules={{required: true}}
                                                        render={({
                                                                     field: {
                                                                         onChange,
                                                                         value,
                                                                         name,
                                                                         ref
                                                                     }
                                                                 }) => {
                                                            const currentSelection = tripOptions.find(
                                                                (c) => c.value === value
                                                            );

                                                            const handleSelectChange = (selectedOption) => {
                                                                onChange(selectedOption?.value);
                                                            };

                                                            return (
                                                                <Select
                                                                    isLoading={isTripsLoading}
                                                                    inputRef={ref}
                                                                    value={currentSelection}
                                                                    name={name}
                                                                    inputId="trip"
                                                                    placeholder={<span className="text-black fs-5">Reisen auswählen</span>}
                                                                    isClearable
                                                                    isSearchable
                                                                    //isMulti
                                                                    options={tripOptions}
                                                                    onChange={handleSelectChange}
                                                                />
                                                            );
                                                        }}
                                                    />
                                                    {errors?.trip &&
                                                        <p className="error"><b>Fehler:</b> Bitte
                                                            Reisen auswählen</p>}
                                                </div>
                                            </div>
                                        </div>
                                    }


                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group mb-3">
                                                <label htmlFor="gender" id={"l-gender"}>Anrede<span
                                                    className="required">*</span></label>
                                                <select id="gender" className="form-control"
                                                        aria-labelledby="l-gender"
                                                        aria-invalid={errors.gender ? "true" : "false"}
                                                        aria-describedby={errors.gender ? "e-gender" : ""}
                                                        {...register(`gender`, {required: true})}
                                                >
                                                    <option value="">Bitte wählen</option>
                                                    <option value="Frau">Frau</option>
                                                    <option value="Herr">Herr</option>
                                                </select>
                                                {errors?.gender &&
                                                    <p className="error" id="e-gender"><b>Fehler:</b> Bitte
                                                        Anrede auswählen</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-3">
                                                <label htmlFor="title" id="l-title">Title</label>
                                                <input
                                                    id="title" className="form-control"
                                                    aria-labelledby="l-title"
                                                    {...register(`title`, {required: false})}
                                                />

                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group mb-3">
                                                <label htmlFor="firstname" id="l-firstname">Vorname<span
                                                    className="required">*</span></label>
                                                <input
                                                    id="firstname" className="form-control"
                                                    aria-labelledby="l-firstname"
                                                    aria-invalid={errors.firstname ? "true" : "false"}
                                                    aria-describedby={errors.firstname ? "e-firstname" : ""}
                                                    {...register(`firstname`, {required: true})}
                                                />

                                                {errors?.firstname &&
                                                    <p className="error" id="e-firstname"><b>Fehler:</b> Vorname ist ein
                                                        Pflichtfeld</p>}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group mb-3">
                                                <label htmlFor="lastname" id="l-lastname">Nachname<span
                                                    className="required">*</span></label>
                                                <input
                                                    id="lastname"
                                                    className="form-control"
                                                    aria-labelledby="l-lastname"
                                                    aria-invalid={errors.lastname ? "true" : "false"}
                                                    aria-describedby={errors.lastname ? "e-lastname" : ""}
                                                    {...register(`lastname`, {required: true})}
                                                />

                                                {errors?.lastname &&
                                                    <p className="error" id="e-lastname"><b>Fehler:</b> Nachname ist ein
                                                        Pflichtfeld</p>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group mb-3">
                                                <label htmlFor="email" id="l-email">Email<span
                                                    className="required">*</span></label>
                                                <input
                                                    id="email"
                                                    className="form-control"
                                                    aria-labelledby="l-email"
                                                    aria-invalid={errors.email ? "true" : "false"}
                                                    aria-describedby={errors.email ? "e1-email" : errors.email?.message ? "e2-email" : ""}
                                                    {...register(`email`, {
                                                        required: true,
                                                        pattern: {
                                                            value: /\S+@\S+\.\S+/,
                                                            message: "Die eingegebene E-Mail stimmt nicht mit dem E-Mail-Format überein",
                                                        },
                                                    })}
                                                />

                                                {errors?.email &&
                                                    <p className="error" id="e1-email"><b>Fehler:</b> E-Mail ist ein
                                                        Pflichtfeld </p>}

                                                {errors?.email?.message &&
                                                    <p className="error" id="e2-email">
                                                        <b>Fehler:</b> {errors.email.message}</p>}
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group mb-5">
                                                <label htmlFor="rating" id="l-rating"
                                                       className="form-check-label">Bewertung<span
                                                    className="required">*</span></label>
                                                <Controller
                                                    control={control}
                                                    aria-labelledby="l-rating"
                                                    aria-invalid={errors.rating ? "true" : "false"}
                                                    aria-describedby={errors.rating ? "e-rating" : ""}
                                                    name="rating"
                                                    rules={{required: true}}
                                                    render={({
                                                                 field: {
                                                                     onChange,
                                                                     value,
                                                                     name,
                                                                     ref
                                                                 }
                                                             }) => {
                                                        const currentValue = value;

                                                        const handleChange = (value) => {
                                                            onChange(value);
                                                        };

                                                        return (
                                                            <ReactStars
                                                                inputId={"rating"}
                                                                count={5}
                                                                size={30}
                                                                inputRef={ref}
                                                                value={currentValue}
                                                                name={name}
                                                                onChange={handleChange}
                                                            />
                                                        );
                                                    }}
                                                />
                                                {errors?.rating &&
                                                    <p className="error" id="e-rating"><b>Fehler:</b> Bitte
                                                        Bewertung auswählen</p>}


                                                <div className="mb-3 mt-3">
                                                    <label htmlFor="floatingTextarea"
                                                           className="form-check-label" id="l-comment">Anmerkung<span
                                                        className="required">*</span></label>
                                                    <textarea className="form-control"
                                                              aria-labelledby="l-comment"
                                                              aria-invalid={errors.comment ? "true" : "false"}
                                                              aria-describedby={errors.comment ? "e1-comment" : errors.comment?.message ? "e2-comment" : ""}
                                                              {...register(`comment`, {
                                                                  required: true,
                                                                  minLength: {
                                                                      value: 30,
                                                                      message: "Die Anmerkung ist zu kurz. Bitte geben Sie mindestens 30 Zeichen ein."
                                                                  }
                                                              })}
                                                              id="floatingTextarea"></textarea>
                                                </div>

                                                {errors?.comment &&
                                                    <p className="error" id="e1-comment"><b>Fehler:</b> Anmerkung ist
                                                        ein Pflichtfeld</p>}

                                                {errors?.comment?.message &&
                                                    <p className="error" id="e2-comment">
                                                        <b>Fehler:</b> {errors.comment.message}</p>}
                                            </div>


                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group mb-3">
                                                <input id="defaultCheck1" className="form-check-input"
                                                       aria-labelledby="l-accept"
                                                       aria-invalid={errors.accept ? "true" : "false"}
                                                       aria-describedby={errors.accept ? "e-accept" : ""}
                                                       type="checkbox"
                                                       {...register(`accept`, {required: true})}/>
                                                <label className="form-check-label"
                                                       htmlFor="defaultCheck1" id="l-accept">
                                                    Ich stimme der Verarbeitung meiner Daten gemäß
                                                    der <a
                                                    href="/datenschutz"
                                                    target="_blank">Datenschutzerklärung</a> zu.
                                                </label>
                                                {errors?.accept &&
                                                    <p className="error" id="e-accept"><b>Fehler:</b> Zustimmung zur
                                                        Datenverarbeitung
                                                        erforderlich.</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {isLoading ? (
                                            <button type="submit"
                                                    className="btn btn-primary talign-center disabled">
                                                <i
                                                    className="fa fa-spinner"></i> Bewertung abgeben
                                            </button>
                                        ) : (
                                            <button type="submit"
                                                    className="btn btn-primary talign-center">Bewertung abgeben
                                            </button>)}
                                    </div>

                                    <ReCAPTCHA
                                        ref={reCaptchaRef}
                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                        size="invisible"
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default ReferencesForm;